export default {
  errorsRootKey: 'field-types',
  resource: 'field-types',
  actions: ['index']
}
